<template>
  <div class="main">

    <el-dialog title="高级检索" :visible.sync="dialogFormVisible" width="80%">

      <el-form :model="form">

        <div v-for="(group, index) in groups" :key="index">
          <div class="dialog-or-block" v-if="index !== 0">
            <p>与/或</p>
            <el-select v-model="group.relation" placeholder="请选择">
              <el-option label="或" value="OR"></el-option>
              <el-option label="与" value="AND"></el-option>
            </el-select>
          </div>
          <div class="dialog-block">
            <p>搜索字段</p>
            <el-select v-model="group.term" placeholder="请选择">
              <el-option v-for="(option, optionIndex) in options" :key="optionIndex" :label="option.label"
                :value="option.value"></el-option>
            </el-select>
            <el-input v-model="group.key" placeholder="值"></el-input>
          </div>
        </div>
        <el-button @click="addGroup">+</el-button>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelComplex">取 消</el-button>
        <el-button type="primary" @click="searchComplex">查 询</el-button>
      </div>

    </el-dialog>

    <div class="right-bar" v-show="!showCategory" @click="showCategory = true">中图分类法搜寻</div>
    <div class="complex-search-btn" v-show="!dialogFormVisible" @click="dialogFormVisible = true">高级检索</div>
    <div class="category-dialog" v-show="showCategory">
      <button class="m-button" @click="showCategory = false">关闭</button>
      <ul class="first-ul">
        <li v-for="menu, index1 in rightbarConfig" :class="{ first: index1 == 0 }" :key="menu.title"
          @click.stop="flatten(menu)">
          <div v-show="!menu.visible" class="right-triangle"></div>
          <div v-show="menu.visible" class="down-triangle"></div>
          {{ menu.title }}
          <ul v-if="menu.children && menu.visible">
            <li v-for="subMenu, index2 in menu.children" :class="{ first: index2 == 0 }" :key="subMenu.title"
              @click.stop="flatten(subMenu)">
              <div v-show="!subMenu.visible && subMenu.children.length > 0" class="right-triangle"></div>
              <div v-show="subMenu.visible && subMenu.children.length > 0" class="down-triangle"></div>
              {{ subMenu.title }}
              <ul v-if="subMenu.children && subMenu.visible">
                <li v-for="thirdMenu, index3 in subMenu.children" :class="{ first: index3 == 0 }" :key="thirdMenu.title"
                  @click.stop="flatten(thirdMenu)">
                  {{ thirdMenu.title }}
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="down-content">
      <div class="side-menu">
        <div class="top-bar">中图分类法</div>

        <div class="category-block">
          <ul>
            <li v-for="menu, index1 in sidebarConfig" :class="{ first: index1 == 0 }" :key="menu.title"
              @click.stop="flatten(menu)">
              <div v-show="!menu.visible" class="right-triangle"></div>
              <div v-show="menu.visible" class="down-triangle"></div>
              {{ menu.title }}
              <ul v-if="menu.children && menu.visible">
                <li v-for="subMenu, index2 in menu.children" :class="{ first: index2 == 0 }" :key="subMenu.title"
                  @click.stop="flatten(subMenu)">
                  <div v-show="!subMenu.visible && subMenu.children.length > 0" class="right-triangle"></div>
                  <div v-show="subMenu.visible && subMenu.children.length > 0" class="down-triangle"></div>
                  {{ subMenu.title }}
                  <ul v-if="subMenu.children && subMenu.visible">
                    <li v-for="thirdMenu, index3 in subMenu.children" :class="{ first: index3 == 0 }"
                      :key="thirdMenu.title" @click.stop="flatten(thirdMenu)">
                      {{ thirdMenu.title }}
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>

      </div>

      <div class="search-content">
        <div v-if="isSearch" class="method-intro">
          <h3>中图法简介</h3>
          <p>《中国图书馆分类法》(原称《中国图书馆图书分类法》)是我国建国后编制出版的一部具有代表性的大型综合性分类法，是当今国内图书馆使用最广泛的分类法体系，简称《中图法》。</p>
          <p>《中图法》的编制始于1971年，先后出版了五版。</p>
          <p>《中图法》与国内其他分类法相比，编制产生年代较晚，但发展很快，它不仅系统地总结了我国分类法的编制经验，而且还吸取了国外分类法的编制理论和技术。
            它按照一定的思想观点，以学科分类为基础，结合图书资料的内容和特点，分门别类组成分类表。</p>
          <p>目前，《中图法》已普遍应用于全国各类型的图书馆，国内主要大型书目、检索刊物、机读数据库，以及《中国国家标准书号》等都著录《中图法》分类号。</p>
          <p style="margin-top: 60px;">《中图法》采用汉语拼音字母与阿拉伯数字相结合的混合号码，用一个字母代表一个大类，以字母顺序反映大类的次序，
            大类下细分的学科门类用阿拉伯数字组成。为适应工业技术发展及该类文献的分类，对工业技术二级类目，采用双字母。</p>
        </div>
        <div v-else>
          <div v-show="complexText" class="complexText">您正在使用高级检索：<p v-html="complexText"></p><button class="m-button"
              @click="cancelComplex">取消搜索</button></div>
          <div class="input-block" v-show="!complexText">
            <!-- <select class="custom-select" v-model="selectedOption" placeholder="请选择" transfer>
            <option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </option>
          </select> -->
            <a-select dropdownClassName="selector" default-value="TITLE" style="width: 120px" @change="handleChange">
              <a-select-option value="AUTHOR">
                作者
              </a-select-option>
              <a-select-option value="TITLE">
                书名
              </a-select-option>
              <a-select-option value="PUBLISHER">
                出版社
              </a-select-option>
              <a-select-option value="ISSN">
                ISBN
              </a-select-option>
              <a-select-option value="DESCRIPTION">
                内容简介
              </a-select-option>
            </a-select>

            <input v-model="search_params.searchText" @keydown.enter="searchFinal" placeholder="搜索电子书">


            <div style="display: flex;gap: 5px;align-items: center;">

              <input v-model="search_params.startYear" @keydown.enter="searchFinal" type="number" placeholder="起始年">
              <p>到</p>
              <input v-model="search_params.endYear" @keydown.enter="searchFinal" type="number" placeholder="终止年">
              <button class="m-button" @click="searchFinal" :disabled="lock">搜索</button>
            </div>

          </div>

          <div class="tag-container" v-show="!complexText">
            <div class="tag" v-for="(param, index) in searchParams" :key="index">
              <span v-if="param.key == 'startYear'" class="tag-text">起始年: {{ param.value }}</span>
              <span v-else-if="param.key == 'endYear'" class="tag-text">终止年: {{ param.value }}</span>
              <span v-else-if="param.key.startsWith('searchText')" class="tag-text">{{ param.value[0] }}: {{
                param.value[1] }}</span>
              <span v-else class="tag-text">{{ param.key }}: {{ param.value }}</span>
              <button class="delete-btn" @click="removeTag(index)">X</button>
            </div>
          </div>

          <div class="title">
            <p>查找结果</p>
          </div>
          <div class="search-list" :class="{ loading: lock }">
            <p class="search-tip" v-show="(!search_result || search_result.length === 0) && !lock">没有资料显示</p>
            <div v-show="search_result && search_result.length > 0" class="search-item"
              v-for="book, index in search_result" :key="book.id" @click="seeDetail(book.md5)">
              <BookItem :src="book.coverUrl" />
              <div class="book-des-part">
                <div class="book-name">{{ (currentPage - 1) * 15 + (index + 1) }} . <div v-html="book.title"></div>
                </div>
                <div class="description" v-html="book.description"></div>

                <div class="desc">
                  <div>Author: <span v-for="(author, index) in book.author" :key="index" v-html="author"></span></div>
                  <div>Publisher: {{ book.publisher }}  </div>
                  <div>Year: {{ book.year }}</div>
                </div>
              </div>

            </div>
          </div>
          <el-pagination v-show="search_result.length > 0" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="15"
            layout="prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>

      <div class="list-block"></div>

    </div>

  </div>
</template>

<script>
import sidebarConfig from '@/utils/sidebar-config.js';
import { searchByAuthor, searchByTitle, searchByPublisher, searchByIsbn, searchByDescription, searchByYear, searchComplex, defaultSearch, allSearch } from '@/_api/book'
import BookItem from '../components/BookItem.vue';


export default {
  components: { BookItem },
  name: "MainView",
  data() {
    return {

      groups: [
        { term: '', key: '' },
        { term: '', key: '', relation: 'AND' }// 初始状态为 "aba"
      ],
      options: [
        { label: '作者', value: 'AUTHOR' },
        { label: '书名', value: 'TITLE' },
        { label: '出版社', value: 'PUBLISHER' },
        { label: 'ISBN', value: 'ISSN' },
        { label: '简介', value: 'DESCRIPTION' }
      ],
      dialogFormVisible: false,
      form: {},
      formLabelWidth: '240px',
      searchParams: [],

      search_params: {
        startYear: '',
        endYear: '',
        searchText: '',
        selectedOption: 'TITLE',
        order: 'YEAR',
      },
      lock: false,
      showCategory: false,
      currentPage: 1,
      total: 1000,
      current: {
        type: undefined,
        sum: null
      },
      sidebarConfig: sidebarConfig,
      rightbarConfig: sidebarConfig,
      isSearch: false,
      search_result: [],
      total: 0,
      lastParams: {},
      lastSearchType: '',
      keywords: [],
      terms: [],
      relations: [],
      complexText: undefined,
      textHeight: '',
      textOpenFlag: false,  // 展开/收起 判定
     showBtnFlag: false,  // 是否显示展开收起
    }
  },
  mounted() {

  },
  created() {
    // 通过 this.$route.query 获取传递的参数
    const params = this.$route.query.searchParams || []; // 确保 params 对象存在
    this.search_params = {
      searchText: params.searchText || '', // 设置默认值为 ''
      startYear: params.startYear || '',
      endYear: params.endYear || '',
      selectedOption: params.selectedOption || 'TITLE',
      order: params.order || 'YEAR',
    };

    if (Object.keys(params).length > 0) {
      this.searchFinal()
    } else {
      this.initData()
    }
  },
  methods: {
    removeTag(index) {
      this.searchParams.splice(index, 1)
      this.search_params = {
        startYear: '',
        endYear: '',
        searchText: '',
        selectedOption: 'TITLE',
        order: 'YEAR',
      }
      this.searchFinal()
    },
    initData() {
      if (this.lock) return
      let searchTerms = '*:*'
      this.lock = true
      allSearch({
        terms: searchTerms,
        page: 1,
        size: 15,
        order: 'YEAR',
        startYear: this.searchParams.find(param => param.key === 'startYear')?.value,
        endYear: this.searchParams.find(param => param.key === 'endYear')?.value,
        clc: this.searchParams.find(param => param.key === '分类')?.value,
      }).then((res) => {
        if (res.status == 'ok') {
          this.search_result = res.data.results
          this.total = res.data.totalElements

          for (let i = 0; i < this.search_result.length; i++) {
            this.search_result[i].coverUrl_temp = this.search_result[i].coverUrl
            this.search_result[i].coverUrl = "http://m15652314175.oicp.net:45449/full-geek/reader/no-auth/notification/cover/" + this.search_result[i].coverUrl
          }

          const containerElement = document.querySelector('.main').scrollIntoView({
            behavior: "smooth", // 平滑过渡
            block: "start", // 上边框与视窗顶部平齐。默认值
          })
        }
      }).finally(() => {
        this.lock = false
      })
    },
    searchFinal() {
      if (this.lock) return
      this.lock = true
      this.currentPage = 1
      const existingStartYearIndex = this.searchParams.findIndex(param => param.key === 'startYear');
      if (existingStartYearIndex !== -1) {
        this.searchParams[existingStartYearIndex].value = this.search_params.startYear;
      } else if (this.search_params.startYear && this.search_params.startYear !== '') {
        this.searchParams.push({ key: 'startYear', value: this.search_params.startYear });
      }

      // Check if endYear already exists in searchParams, if yes, update its value
      const existingEndYearIndex = this.searchParams.findIndex(param => param.key === 'endYear');
      if (existingEndYearIndex !== -1) {
        this.searchParams[existingEndYearIndex].value = this.search_params.endYear;
      } else if (this.search_params.endYear && this.search_params.endYear !== '') {
        this.searchParams.push({ key: 'endYear', value: this.search_params.endYear });
      }

      // 增加多个searchText的方法
      // 搜索框中有值 开始写入tag
      if (this.search_params.searchText && this.search_params.searchText !== '') {
        let keyCount = 1
        let newKey = 'searchText'
        while (this.searchParams.some(param => param.key === newKey)) {
          keyCount++
          newKey = `searchText${keyCount}`
        }

        this.searchParams.push({ key: newKey, value: [this.search_params.selectedOption, this.search_params.searchText] })
      }

      // this.searchParams.push({ key: 'order', value: 'YEAR' })

      let searchTerms = '*:*'
      let tempSearchTerms = ''
      this.searchParams.forEach((param, index) => {

        if (!param.key.startsWith('searchText')) {
          return;
        }

        const searchTextKey = param.key;
        const searchTextValue = param.value[1]

        if (tempSearchTerms !== '') {
          tempSearchTerms += ' OR '
        }

        tempSearchTerms += `${param.value[0]}:"${searchTextValue}"`
      })
      if (tempSearchTerms.length > 0) searchTerms = tempSearchTerms


      allSearch({
        terms: searchTerms,
        page: 1,
        size: 15,
        order: 'YEAR',
        startYear: this.searchParams.find(param => param.key === 'startYear')?.value,
        endYear: this.searchParams.find(param => param.key === 'endYear')?.value,
        clc: this.searchParams.find(param => param.key === '分类')?.value,
      }).then((res) => {
        if (res.status == 'ok') {
          this.search_result = res.data.results
          this.total = res.data.totalElements

          for (let i = 0; i < this.search_result.length; i++) {
            this.search_result[i].coverUrl_temp = this.search_result[i].coverUrl
            this.search_result[i].coverUrl = "http://m15652314175.oicp.net:45449/full-geek/reader/no-auth/notification/cover/" + this.search_result[i].coverUrl
          }

          const containerElement = document.querySelector('.main').scrollIntoView({
            behavior: "smooth", // 平滑过渡
            block: "start", // 上边框与视窗顶部平齐。默认值
          });
        }
      }).finally(() => {

        this.lock = false
      })

    },
    cancelComplex() {
      this.dialogFormVisible = false
      this.groups = [
        { term: '', key: '' },
        { term: '', key: '', relation: 'AND' } // 初始状态为 "aba"
      ]
    },
    searchComplex() {
      if (this.lock) return
      this.lock = true
      this.dialogFormVisible = false
      this.keywords = this.groups.map(group => group.key);
      this.terms = this.groups.map(group => group.term);
      this.relations = this.groups.map(group => group.relation);

      let complexText = '';
      let searchText = '';
      for (let i = 0; i < this.groups.length; i++) {
        if (i !== 0) {
          complexText += ' ' + this.relations[i]; // 添加关系
          searchText += ' ' + this.relations[i]
        }
        searchText += " " + this.terms[i] + `:"` + this.keywords[i] + `"`  // 添加关键字和术语
        complexText += '<span>' + this.keywords[i] + '</span>'; // 添加关键字和术语
      }
      this.complexText = complexText

      let c_params


      c_params = {
        terms: searchText,
        page: 1,
        size: 10
      }

      console.log(c_params)

      allSearch(c_params).then((res) => {
        if (res.status == 'ok') {
          console.log(res)
          this.search_result = res.data.results
          this.total = res.data.totalElements
          this.lastParams = c_params
          for (let i = 0; i < this.search_result.length; i++) {
            this.search_result[i].coverUrl_temp = this.search_result[i].coverUrl
            this.search_result[i].coverUrl = "http://m15652314175.oicp.net:45449/full-geek/reader/no-auth/notification/cover/" + this.search_result[i].coverUrl
          }
          
        }
      }).finally(() => {
        this.lock = false
      })
    },
    addGroup() {
      this.groups.push({ term: '', key: '', relation: 'AND' });
    },
    seeDetail(md5) {
      this.$router.push({
        path: '/book/' + md5,
      });
    },
    cancelComplex() {
      this.defaultSearch()
      this.lastParams = {}
      this.lastSearchType = ''
      this.complexText = undefined
    },
    search() {
      switch (this.search_params.selectedOption) {
        case 'author':
          this.searchByAuthor();
          break;
        case 'md5':
          this.searchByTitle();
          break;
        case 'publisher':
          this.searchByPublisher();
          break;
        case 'issn':
          this.searchByIssn();
          break;
        case 'description':
          this.searchByDescription();
          break;
        default:
          // 如果选项不匹配任何情况，执行默认的搜索方法或者提示错误
          break;
      }
    },
    checkYear() {
      if (this.search_params.startYear && this.search_params.endYear) {
        return this.search_params.startYear < this.search_params.endYear
      } else {
        return true
      }
    },
    handleChange(value) {
      console.log(value)
      this.search_params.selectedOption = value
    },
    flatten(item) {
      // 代表进行搜寻
      if (item.children.length == 0) {
        if (this.lock) return
        for (let i = 0; i < this.searchParams.length; i++) {
          if (this.searchParams[i].key == '分类') {
            this.searchParams.splice(i, 1)
            break
          }
        }
        this.searchParams.push({ key: '分类', value: item.title })
        this.searchFinal()
        // let c_params = {
        //   page: 1,
        //   size: 10,
        //   clc: item.title
        // }

        // defaultSearch(c_params).then((res) => {
        //   this.current.type = item.title
        //   if(res.status == 'ok'){
        //     this.current.sum = res.data.totalElements
        //   }
        // })
      } else {
        item.visible = !item.visible
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      if (this.lock) return
      this.currentPage = val

      this.lock = true

      let searchTerms = '*:*'

      this.searchParams.forEach((param, index) => {
        if (!param.key.startsWith('searchText')) {
          return;
        }
        searchTerms = ''
        const searchTextKey = param.key;
        const searchTextValue = param.value[1]

        if (searchTerms !== '') {
          searchTerms += ' OR '
        }

        searchTerms += `${param.value[0]}:"${searchTextValue}"`
      })

      allSearch({
        terms: searchTerms,
        page: this.currentPage,
        size: 15,
        order: 'YEAR',
        startYear: this.searchParams.find(param => param.key === 'startYear')?.value,
        endYear: this.searchParams.find(param => param.key === 'endYear')?.value,
        clc: this.searchParams.find(param => param.key === '分类')?.value,
      }).then((res) => {
        if (res.status == 'ok') {
          this.search_result = res.data.results
          this.total = res.data.totalElements
          for (let i = 0; i < this.search_result.length; i++) {
            this.search_result[i].coverUrl_temp = this.search_result[i].coverUrl
            this.search_result[i].coverUrl = "http://m15652314175.oicp.net:45449/full-geek/reader/no-auth/notification/cover/" + this.search_result[i].coverUrl
          }
          const containerElement = document.querySelector('.main').scrollIntoView({
            behavior: "smooth", // 平滑过渡
            block: "start", // 上边框与视窗顶部平齐。默认值
          });
        }
      }).finally(() => {

        this.lock = false
      })
    }
  }
}
</script>
<style lang="less">
::v-deep .el-pagination {
  margin-bottom: 10px;
}

::v-deep .el-pager li.active {
  color: #62CD48;
  cursor: default;
}

::v-deep .el-pager li:hover {
  color: #35921e;
}
</style>
<style lang="less">
.main {
  .right-bar {
    position: fixed;
    top: 120px;
    right: 0;
    width: min-content;
    padding: 10px;
    background: var(--head-line);
    color: #FFFFFF;
    border-radius: 10px 0 0 10px;
    display: none;

    @media screen and (max-width:900px) {
      display: block;
    }
  }

  .top-bar {
    background: var(--button);
    color: var(--head-line);
    padding: 10px 35px;
    width: 100%;
    font-weight: 900;
    font-size: 16px;
  }

  .down-content {
    width: 100vw;
    display: flex;

    .search-content {
      border-top: 1px solid #E2E2E2;
      flex: 1;

      @media screen and (max-width:900px) {
        margin-top: 30px;
      }

      .method-intro {
        padding: 25px;
      }

      .title {
        margin-top: 20px;
        width: 100%;
        padding: 10px 15px 10px 35px;
        font-size: 15px;
        width: 100%;
        background: transparent;
        border-bottom: 1px solid #E2E2E2;
        color: black;
        display: flex;
        gap: 20px;

        p {
          margin: 0 !important;
        }
      }

      .search-item {
        display: flex;
        letter-spacing: .3px;
        padding: 33px;
        border-bottom: 1px solid #e5e5e5d6;
        cursor: pointer;
        align-items: center;
        .book-des-part {
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 5px;
          letter-spacing: .3px;
          padding-left: 40px;
        }
      }

      .desc {
        display: flex;
        flex-direction: column;
        gap: 10px;
        font-size: 13px;
        color: #131313;
        margin-left: 25px;
        text-decoration: underline;
      }

      p {
        margin-bottom: 0 !important;
        // margin-left: 15px;
      }

      .book-name {
        display: flex;
        gap: 10px;
        color: #000000;
        font-size: medium;
        font-weight: 700;
      }

      .description {
        padding: 8px 25px;
        max-height: 240px;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        margin: 12px 0;
      }
    }
  }

  .category-dialog {
    background: var(--background-color);

    .m-button {
      width: max-content;
      font-size: 12px;
      color: #FFFFFF;
      float: right;
      height: 30px;
      margin-top: 10px;
      margin-right: 10px;
    }

    .first-ul {
      padding-top: 40px;
    }


    .right-triangle {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 6px 0 6px 9px;
      /* Top, Right, Bottom, Left */
      border-color: transparent transparent transparent #96C14E;
      /* Transparent on the top, right, and bottom; black on the left */
      display: inline-block;
    }

    .down-triangle {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 9px 6px 0 6px;
      /* Top, Right, Bottom, Left */
      border-color: #00214D transparent transparent transparent;
      /* Black on the top; transparent on the right, bottom, and left */
      display: inline-block;
    }

    li {
      font-size: 12px;
      letter-spacing: 1px;
      color: #000000;
      padding: 5px 0 5px 30px;
      cursor: default;
      user-select: none;
      list-style-type: none;
    }

    .first {
      padding: 5px 0 0px 30px;
    }

  }

  .side-menu {
    width: 40vw;
    max-width: 400px;
    background: var(--background-color);

    @media screen and (max-width:900px) {
      display: none;
    }


    .title {
      padding: 10px 15px 10px 35px;
      font-size: 15px;
      width: 100%;
      background: #E2E2E2;
      color: black;
      display: flex;
      gap: 20px;

      p {
        margin: 0 !important;
      }

      span {
        color: var(--head-line);
        font-weight: 700;
      }
    }

    .category-block {
      padding-top: 5px;

      .right-triangle {
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 6px 0 6px 9px;
        /* Top, Right, Bottom, Left */
        border-color: transparent transparent transparent #96C14E;
        /* Transparent on the top, right, and bottom; black on the left */
        display: inline-block;
      }

      .down-triangle {
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 9px 6px 0 6px;
        /* Top, Right, Bottom, Left */
        border-color: #00214D transparent transparent transparent;
        /* Black on the top; transparent on the right, bottom, and left */
        display: inline-block;
      }

      li {
        font-size: 14px;
        letter-spacing: 1px;
        color: #000000;
        padding: 5px 0 5px 30px;
        cursor: default;
        user-select: none;
        list-style-type: none;
      }

      .first {
        padding: 5px 0 0px 30px;
      }
    }

  }

}

.input-block {
  width: 100%;
  display: flex;
  gap: 20px;
  padding: 10px 0 0 30px;
  line-height: 40px;
  align-items: center;
  flex-wrap: wrap;

  .m-button {
    color: white;
    font-size: 14px;
    letter-spacing: 3px;
    width: max-content;
  }

  @media screen and (max-width:500px) {
    padding: 10px 0 0 10px;
  }

  .ant-select-selection {
    height: 40px;
    width: 120px;
  }

  .ant-select-selection__rendered {
    display: flex;
    justify-content: center;
    width: 120px;
    line-height: 40px;
    text-align: center;
    margin: 0;
    margin-left: -10px;
    font-size: 13px;
  }

  input {
    background-color: rgba(255, 255, 255, 0.5);
    padding: 15px 10px;
    height: 40px;
    font-size: 13px;
    min-width: 200px;
  }

}

.select-block {
  display: flex;
  gap: 10px;
  height: 40px;
  align-items: center;
  line-height: 40px;
  padding: 20px 0 0 30px;

  @media screen and (max-width:500px) {
    padding: 28px 0 0 10px;
  }

  input {
    background-color: rgba(255, 255, 255, 0.5);
    padding: 5px 10px;
    height: 40px;
    font-size: 13px;
    width: 100px;
    text-align: center;
  }

  .m-button {
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 1px;
    height: 40px;
  }
}

.search-list {
  min-height: calc(100vh - 285px);

  .search-tip {
    font-size: 22px;
    font-style: italic;
    font-weight: bold;
    margin: 50px 0 0 40px;
  }

  @media screen and (max-width:900px) {
    min-height: 0;
  }
}

.dialog-block {
  display: flex;
  gap: 10px;
  line-height: 40px;

  p {
    width: 100px;
  }
}

.dialog-or-block {
  display: flex;
  gap: 10px;
  justify-content: center;
  line-height: 40px;
}

.complexText {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
  gap: 3px;
  font-size: 16px;

  span {
    color: #00214D;
    display: inline-block;
    margin: 5px;
  }

  .m-button {
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 400;
    margin-left: 30px;
  }
}

.complex-search-btn {
  position: fixed;
  top: 320px;
  right: 0;
  width: min-content;
  padding: 10px;
  background: var(--head-line);
  color: #FFFFFF;
  border-radius: 10px 0 0 10px;
}

.tag-container {
  display: flex;
  flex-wrap: wrap;
  padding: 20px 0 0 30px;
}

.tag {
  display: flex;
  align-items: center;
  margin-right: 10px;
  margin-bottom: 5px;
  padding: 5px 10px;
  background-color: var(--head-line);
  color: white;
  border-radius: 20px;
  font-size: 13px;
}

.tag-text {
  margin-right: 5px;
}

.delete-btn {
  border: none;
  background-color: white;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  cursor: pointer;
  font-size: 13px;
  color: #000000;
  font-weight: 700;
}
</style>